import React from 'react';

/* Small inline icons for the landing page. The app-wide react-icons context
   adds a global `.react-icon` size and colour, which these avoid. */

const iconProps = {
  'aria-hidden': true,
  focusable: false,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

/** A clapperboard slate: striped sticks over the board. */
export const BrandMark: React.FC = () => (
  <svg className="lp-brand-mark" viewBox="0 0 28 28" aria-hidden="true" focusable="false">
    <rect x="3" y="12" width="22" height="13" rx="2" fill="currentColor" />
    <g transform="rotate(-14 3 10)">
      <rect x="3" y="5" width="22" height="5.5" rx="1.2" fill="currentColor" />
      <path d="M8 5h3.4l-2.6 5.5H5.4zM15 5h3.4l-2.6 5.5h-3.4zM22 5h3l-.2.4-2.4 5.1h-3.4z" fill="var(--lp-bg)" />
    </g>
    <path d="M7 16.5h8M7 20h12" stroke="var(--lp-bg)" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const ArrowIcon: React.FC = () => (
  <svg className="lp-icon" viewBox="0 0 20 20" {...iconProps}>
    <path d="M4 10h11M11 5.5 15.5 10 11 14.5" />
  </svg>
);

export const PlayIcon: React.FC = () => (
  <svg className="lp-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <path d="M6.5 4.8v10.4a.6.6 0 0 0 .9.5l8.3-5.2a.6.6 0 0 0 0-1L7.4 4.3a.6.6 0 0 0-.9.5z" fill="currentColor" />
  </svg>
);

export const ChevronIcon: React.FC = () => (
  <svg className="lp-icon lp-chevron" viewBox="0 0 20 20" {...iconProps}>
    <path d="m6 8 4 4 4-4" />
  </svg>
);

export const MenuIcon: React.FC = () => (
  <svg className="lp-icon" viewBox="0 0 24 24" {...iconProps}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const CloseIcon: React.FC = () => (
  <svg className="lp-icon" viewBox="0 0 24 24" {...iconProps}>
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const CheckIcon: React.FC = () => (
  <svg className="lp-icon" viewBox="0 0 20 20" {...iconProps}>
    <path d="m4.5 10.5 3.5 3.5 7.5-8" />
  </svg>
);
